import { FC } from 'react';

import ConfirmationModalV2 from '@layouts/modal/ConfirmationModal.v2';

interface DeleteConfirmationModalV2Props {
  showDeleteModal: boolean;
  handleConfirmDelete: () => void;
  handleCancel: () => void;
  title: string;
  message: string;
  isConfirmButtonLoading?: boolean;
}

const DeleteConfirmationModalV2: FC<DeleteConfirmationModalV2Props> = ({
  showDeleteModal,
  handleCancel,
  handleConfirmDelete,
  title,
  message,
  isConfirmButtonLoading = false
}) => {
  if (!showDeleteModal) return null;

  return (
    <ConfirmationModalV2
      iconName="trash-round"
      iconSize="48"
      title={title}
      description={message}
      confirmButtonLabel="Delete"
      cancelButtonLabel="Cancel"
      onConfirm={handleConfirmDelete}
      onCancel={handleCancel}
      className="!w-105"
      contentClassName="!gap-6"
      isConfirmButtonLoading={isConfirmButtonLoading}
    />
  );
};

export default DeleteConfirmationModalV2;
